<template>
  <div class="smsVerificationWrapper text-center">
    <p class="title">{{ $t('Phone number') }}</p>
    <ValidationObserver ref="numberForm" id="numberForm">
      <div class="inputWrapper">
        <div class="col-lg-3 p-0" ref="selectWrapper" @mousedown="showOptions">
          <cool-select
            v-model="selectedCountry"
            :items="items"
            item-value="code"
            item-text="name"
            @select="onCountrySelected"
            @input="hideOptions"
            @blur="hideOptions"
          >
            <template slot="item" slot-scope="{ item }">
              <div class="country-item">
                <img class="country-flag" :src="getFlag(item.code)" :alt="item.name">
                <b class="country-code">{{ $t(item.name) }}</b>
              </div>
            </template>
            <template slot="selection" slot-scope="{ item }">
              <ValidationProvider tag="div" name="Ländervorwahl" :rules="'required'" v-slot="{ errors }">
                <div :style="inputStyles" class="country-selected-item" :class="{'is-invalid': errors.length}">
                  <img class="country-flag" v-if="item.phoneCode" :src="getFlag(item.code)" :alt="item.code">
                  <div class="custom-input-wrap" v-if="item.code === 'other'">
                    <span>+</span>
                    <input ref="customInput" @keypress="onlyNumber" v-model="countryCode" type="text" class="custom-input" maxlength="4" title="Country code" aria-label="Country code">
                    <img v-if="errors.length" class="custom-input-warn" src="../../../assets/icons/risk-icon.svg" height="18px" width="18px" alt="">
                  </div>
                  <input v-else v-model="countryCode" type="hidden">
                  <b v-if="item.phoneCode" class="country-code">{{ item.phoneCode }}</b>
                </div>
                <div class="validation-error" v-if="errors.length">{{ errors[0] }}</div>
              </ValidationProvider>
            </template>
          </cool-select>
        </div>

        <textInput
          name="phoneNumber"
          id="phoneNumber"
          v-model="tel"
          class="phoneNumber col-lg-10"
          label="Mobile number"
          placeholder="Mobile number"
          :validation="`required|integer|mobileNumber:${countryCode}`"
          :labelOnTop="false"
          :noLabel="true"
          :styles="inputStyles"
          :slideUp="tel != ''"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import textInput from "@/components/renderers/text-input.vue";
import { CoolSelect } from "vue-cool-select";
import("vue-cool-select/dist/themes/bootstrap.css");
import { mapMutations } from 'vuex';

export default {
  name: "sms-verification",
  components: { textInput, CoolSelect },
  props: {
    successAction: Object,
    generateUrl: String,
    authUrl: String,
    onSuccess: {
      type: Object
    },
    inputStyles:{
      type:Object,
      required:false,
      default:()=>{}
    }
  },
  data () {
    return {
      options: [
        { value: "+49", text: "+49" },
        { value: "+90", text: "+90" },
        { value: "+389", text: "+389" }
      ],
      countryCode: "",
      selectedCountry: "",
      tel: "",
      items: [
        {
          "name": "Denmark",
          "code": "DK",
          "phoneCode": "+45"
        },
        {
          "name": "Norway",
          "code": "NO",
          "phoneCode": "+47"
        },
        {
          "name": "Finland",
          "code": "FI",
          "phoneCode": "+358"
        },
        {
          "name": "Sweden",
          "code": "SE",
          "phoneCode": "+46"
        }
      ]
    };
  },
  methods: {
    ...mapMutations(['setCountryCode', 'setTel']),
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },
    async goto (page) {
      const isValid = await this.$refs.numberForm.validate();
      if(!isValid) {
        this.scrollTo(`[id=numberForm`);
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false
        });
      }

      const formData = {
        mobile: `+${this.countryCode}${this.tel}`
      };
      const apiUrl = this.generateUrl;

      this.$store.dispatch("generateCode", { formData, apiUrl }).then(r => {
        this.setCountryCode(this.countryCode);
        this.setTel(this.tel);
        const fn = this.successAction.fn;
        const params = this.successAction.params;
        this[fn](params, this);
      });
    },
    getFlag (flagName) {
      try {
        return require(`../../../assets/icons/flags/${flagName.toLowerCase()}.svg`);
      } catch (e) {
        return ""
      }
    },
    onCountrySelected (item) {
      if (item.code === "other") {
        this.$refs.customInput.focus()
        this.countryCode = ""
      }
      if (item.phoneCode) {
        this.countryCode = +item.phoneCode
      }
      this.hideOptions();
    },
    showOptions () {
      this.$refs.selectWrapper.classList.remove('hide')
    },
    hideOptions () {
      this.$refs.selectWrapper.classList.add('hide')
    }
  },
  mounted () {
    this.$eventHub.$on('sendSms-event', this.goto)
    this.selectedCountry = this.items[0].code
    this.countryCode = +this.items[0].phoneCode
  },
  beforeDestroy () {
    this.$eventHub.$off('sendSms-event', this.goto)
  }
};
</script>
<style lang="scss" scoped>

.smsVerificationWrapper {
  font-family: inherit;
  max-width: 1440px;
  .description {
    font-size: 14px;
    &.bigger {
      font-size: 16px;
      font-weight: 400;
    }
  }
}

.title {
  text-align: left;
  font-weight: bold;
  color: var(--text-color-4);
}

.inputWrapper {
  display: flex;
  justify-content: center;
  .countryCode {
    font-size: 10px;
    width: 120px !important;
  }
  .phoneNumber {
    min-width: 185px;
  }
  .verificationCode {
    width: 200px;
  }
}

.country-flag {
  width: 30px;
}

/deep/ .IZ-select {
  justify-content: center;
  width: 100%;
  border-radius: 100px;
  .validation-error {
    margin-left: 0;
  }

  .IZ-select__input {
    border: none;
    box-shadow: none;
    width: 100px;
    padding-left: 0;
  }

  .IZ-select__menu {
    width: 200px !important;
  }

  .IZ-select__input--selection-slot {
    & > div {
      flex: 1 1 auto;
    }
  }

  input {
    display: none;

    &.custom-input {
      display: block;
    }
  }
}

/deep/ .hide .IZ-select__menu {
  clip-path: polygon(0px 0px, 0px 0px, 0px 0px, 0px 0px);
}

.country-selected-item {
  height: 48px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #D1E7FF !important;
  cursor: pointer;
  border-radius: var(--field-radius);
  &.is-invalid {
    border-color: #dc3545;
    background-color: #fff0f1;
  }

  .country-code {
    font-weight: 400;
    padding-left: 5px;
  }
  .custom-input-wrap {
    padding-left: .75rem;
    display: inline-flex;
    align-items: center;

    .custom-input {
      padding-left: 4px;
      padding-right: 28px;
    }
    .custom-input-warn {
      position: absolute;
      right: 15px;
      width: 16px;
    }
  }
}

.country-item {
  display: flex;
  align-items: center;

  .country-code {
    margin-left: 10px;
  }
}

.subHeading {
  text-align: center;
  font: normal normal 500 20px/24px 'Plus Jakarta Sans', Medium;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin: 0 auto;
}

.zurechBtn {
  border: 1px solid #FF4D56;
  background-color: white;
  color: var(--color1);
  border-radius: 6px;
  opacity: 1;

  font: normal normal 500 20px/24px 'Plus Jakarta Sans', Medium;
  letter-spacing: 0px;
  color: #FF4D56;
  opacity: 1;

  max-height: 50px;
}

.codeBtn {
  background: var(--color4) 0% 0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;

  font: normal normal 500 20px/24px 'Plus Jakarta Sans', Medium;
  letter-spacing: 0px;
  color: #FBFBFB;
  opacity: 1;

  &Wrapper {
    padding-bottom: 15px;
  }
}

@media (max-width: 991px) {

  .heading { font: normal normal 600 24px/34px 'Plus Jakarta Sans' !important; }
  .subHeading { font: normal normal normal 16px/20px 'Plus Jakarta Sans' !important; }

  .btnWrapper {
    flex-direction: column;
  }

}

@media (min-width: 992px) {
  .codeBtnWrapper { display: none; }
}

</style>
